export const paths = {
	root: '/ibNotifications',
    notifications: '/ibNotifications/notifications',
    details: '/ibNotifications/:safetyId',
    view: '/ibNotifications/:safetyId/view',
    viewRecipientStudyDoc: '/ibNotifications/viewStudyDoc/:safetyId/:slOrgId',
};

export const navigation = {
    details: id => `/ibNotifications/${id}`,
    viewIB: safetyId => `/ibNotifications/${safetyId}/view`,
    viewRecipientStudyDoc: (safetyId, slOrgId) => `/ibNotifications/viewStudyDoc/${safetyId}/${slOrgId}`,
};
